exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-padding{padding:0!important}.customTable{width:83%;height:auto;margin-bottom:10px;padding-left:20px}.table-c{padding-bottom:20px!important;margin-bottom:30px!important;border-bottom:1px solid #ddd}.customTable .item_a{width:15%;height:auto;float:left}.customTable .item_b{width:20%;height:auto;float:left}.customTable .item_c{width:4%;height:auto;float:left;text-align:center}.alertIcon{width:20px;margin:0 auto}.clear{clear:both}.custom_btn_close{position:absolute!important;right:24px!important}", ""]);

// exports
